module.exports = __webpack_public_path__ + "img/mobile-banner0-cn.b5b65898.jpg";